export default __webpack_public_path__ + "static/media/06.01dfd387.jpg";